import React, { useContext, useEffect, useState } from "react";
import "../CreateProposal/CreatePRopesoal.css";
import Application from "../../../StateContext/Application.js";
import {
  Back32,
  Cancel32,
  ProposalCreation32,
  submit,
} from "../../../../../public/LoginImages/importimages.js";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useLanguage } from "../../../../../lang/langcontext/LanguageContext.js";
import { jwtDecode } from "jwt-decode";

const EditProposal = () => {
  const [userData, setUserData] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem("Token");
    if (token) {
      try {
        // Decode the JWT token to get user details
        const decoded = jwtDecode(token);
        setUserData(decoded);
        console.log("Logged User Info:", decoded);
      } catch (error) {
        console.error("Invalid token:", error);
      }
    }
  }, []);
  const { language, toggleLanguage, t } = useLanguage();
  const { id } = useParams();
  const nav = useNavigate();
  const urlLocation = useLocation();
  const urlType = urlLocation.state?.type;

  const operation = useContext(Application);
  const {
    ProposalCreation,
    GetBudgetHeadInfo,
    GetAllSchemes,
    CreateMapCoordinateforProposal,
    GetGramPanchayatCodes,
    TypesOfWork,
  } = operation;

  const [HeadInfo, setHeadInfo] = useState([]);
  const [Taluka, setTaluka] = useState([]);
  const [gramPanchayat, setgramPanchayat] = useState([]);
  const [Scheme, setScheme] = useState([]);
  const [diableChoosebutton, setDisableChoosebutton] = useState(false);
  const [locationData, setLocationData] = useState(null);
  const [switchshow, setSwitchShow] = useState(0);
  const [GPname, setGPname] = useState([]);
  const [WorkId, setWorkId] = useState([]);
  const [getWork, setWork] = useState([]);
  const [showPopup, setShowPopup] = useState(false);
  const [tempGramPanchayat, setTempGramPanchayat] = useState([]);

  const [data, setData] = useState({
    PID: id,
    HeadCode: "",
    ProposalYear: "",
    SchemeName: "",
    District: "",
    Taluka: "",
    ConstituencyName: "",
    TalukaSelection: "",
    GramPanchayat: [],
    WorkName: "",
    ProposalFileNumber: "",
    ProposalAmount: "",
    Area: "",
    Type: "",
    workType: "",
    isMultipleGp: "",
    Remark: "",
    workClass: "",
    RoadCategory: "",
    RoadNumber: "",
    ProposalWorkAmount: "",
    proposedLength: "",
    TotalProposalAmount: "",
    CommonID: "",
    JOB_ID: "",
  });

  const [loading, setLoading] = useState(false);

  const HandleChangeData = (e) => {
    const { name, value } = e.target;

    if (name === "Taluka") {
      const [ULBName, District] = value.split("|");
      setData((prev) => ({
        ...prev,
        Taluka: ULBName,
        District: District,
        TalukaSelection: value,
      }));
    } else {
      setData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const formData = new FormData();

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (
      data.workClass === "Choose Class Of Work" ||
      !data.workClass ||
      data.workClass.trim() === ""
    ) {
      alert("Please select Class Of Work before saving.");
      return;
    }

    if (
      !data.workType ||
      data.workType.trim() === "" ||
      data.workType === "Choose Type of Work"
    ) {
      alert("Please select Type Of Work before saving.");
      return;
    }
    if (
      data.isMultipleGp === "No" &&
      (!data.GramPanchayat || data.GramPanchayat.length === 0)
    ) {
      alert("Please select a Gram Panchayat before saving.");
      return;
    }
    if (data.isMultipleGp === "Yes" && data.GramPanchayat.length < 2) {
      alert("You have to select at least 2 Gram Panchayats.");
      return;
    }
    if (data.ProposalAmount <= 0) {
      alert("Work Amount must be greater that 0 ");
      return;
    }
    if (
      !data.RoadNumber?.trim() ||
      !data.ProposalAmount ||
      !data.proposedLength?.trim() ||
      !data.WorkName?.trim()
    ) {
      alert("You have to Fill All Mandatory Fields");
      return;
    }
    if (userData?.RoleID !== 41 && !data.JOB_ID) {
      alert("Please enter JOB ID");
      return;
    }
    setLoading(true);

    let shouldSubmit = window.confirm("Are you Sure ??");
    if (shouldSubmit) {
      try {
        const currentProposalAmt = parseFloat(data.ProposalAmount) || 0;
        const remainingTotal = parseFloat(data.TotalProposalAmount) || 0;
        const finalTotal = `${remainingTotal + currentProposalAmt}`;

        for (const key in data) {
          let value = data[key];
          if (key == "GramPanchayat") {
            formData.append(key, JSON.stringify(value));
          } else if (key == "TotalProposalAmount") {
            formData.append(key, finalTotal);
          } else {
            formData.append(key, data[key]);
          }
        }

        formData.append("ActionType", "EditProposal");
        let result = await ProposalCreation(formData);
        const { status, message } = result;

        if (status) {
          alert(message);
          nav(-1);
        } else {
          alert(message);
          setLoading(false);
        }
      } catch (err) {
        console.log(err);
        alert("Error while Updating Proposal !!!");
        setLoading(false);
      } finally {
        setLoading(false);
      }
    } else {
      alert("Proposal Edit Operation Cancel !!!");
      setLoading(false);
    }
  };
  const FetchHeadInfo = async () => {
    setLoading(true);
    try {
      let res = await GetBudgetHeadInfo("null", "all");
      let res1 = await GetBudgetHeadInfo("null", "GetTalukas");
      console.log("Data i get from Bakcend :: ", res);
      console.log("Data i get:: ", res1);
      setHeadInfo(res);
      setTaluka(res1);
    } catch (err) {
      console.log(err);
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    FetchHeadInfo();
  }, []);

  const GetGramPanchayat = async () => {
    try {
      let res = await GetGramPanchayatCodes(GPname, "Proposal");
      console.log(GPname);
      console.log("Data of grampanchayat:: ", res);
      // let GramPanchayat = res.filter((item) => item.Development_Block_Name === GPname);
      console.log("Data of grampanchayat:: ", res);
      setgramPanchayat(res);
    } catch (err) {
      console.log(err);
    }
  };

  const getEnglishNameOFTaluka = async () => {
    let res = await GetBudgetHeadInfo("null", "GetTalukas");
    let talukaNameEnglish = res.filter(
      (item) => item.ULBNameMarathi === data.Taluka,
    );
    console.log("Data of taluka:: ", talukaNameEnglish);
    if (talukaNameEnglish.length > 0) {
      setGPname(talukaNameEnglish[0].ULBName); // English name
    } else {
      console.warn("No matching Taluka found for Marathi name:", data.Taluka);
      setGPname("");
    }
  };
  useEffect(() => {
    getEnglishNameOFTaluka();
  }, [data.Taluka]);

  useEffect(() => {
    if (GPname) {
      GetGramPanchayat();
    }
  }, [GPname]);

  const FetchedIntitialData = async () => {
    setLoading(true);
    try {
      let res = await GetBudgetHeadInfo(id, "GetSpecificProposalInfo");
      console.log("Data i get from Bakcend :: ", res);
      let proposalInfo = res[0];

      const {
        HeadCode,
        Proposal_year,
        SchemeName,
        District,
        Taluka: TalukaName,
        Constituency_name,
        Gram_panchayat,
        Work_name,
        Proposal_fileNumber,
        Proposal_amount,
        Proposal_copy,
        Additional_suppDoc,
        Type,
        isMultipleGP,
        classOfWork,
        typeOfWork,
        roadCategory,
        roadNumber,
        proposedLength,
        workRemark,
        TotalProposalAmount,
        workuniqueid,
        JOB_ID,
      } = proposalInfo;

      let talukaInfo =
        Taluka.find(
          (t) => t.ULBNameMarathi === TalukaName || t.ULBName === TalukaName,
        ) || {};

      let TalukaSelectionValue = talukaInfo.ULBNameMarathi
        ? `${talukaInfo.ULBNameMarathi}|${talukaInfo.District_Marathi}`
        : "";

      const proposalAmt = parseFloat(Proposal_amount) || 0;
      const totalAmt = parseFloat(TotalProposalAmount) || 0;

      const remainingTotal = `${totalAmt - proposalAmt}`;

      setData({
        ...data,
        PID: id,
        HeadCode: HeadCode,
        ProposalYear: Proposal_year,
        SchemeName: SchemeName,
        District: District,
        Taluka: TalukaName,
        ConstituencyName: Constituency_name,
        TalukaSelection: TalukaSelectionValue,
        GramPanchayat: JSON.parse(Gram_panchayat),
        WorkName: Work_name,
        ProposalFileNumber: Proposal_fileNumber,
        ProposalAmount: Proposal_amount,
        Type: Type,
        ProposalCopy: Proposal_copy,
        AdditionalSupportingDocument: Additional_suppDoc,
        isMultipleGp: isMultipleGP,
        workType: typeOfWork,
        Remark: workRemark,
        workClass: classOfWork,
        RoadCategory: roadCategory,
        RoadNumber: roadNumber,
        ProposalWorkAmount: Proposal_amount,
        proposedLength: proposedLength,
        TotalProposalAmount: remainingTotal,
        CommonID: workuniqueid,
        JOB_ID: JOB_ID,
      });
    } catch (err) {
      console.log(err);
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (Taluka.length > 0) {
      FetchedIntitialData();
    }
  }, [Taluka]);

  const GetTypesOfWork = async () => {
    console.log(data.HeadCode);
    try {
      let res = await TypesOfWork(data.HeadCode);
      setLoading(true);
      setWorkId(res);
      console.log("Type Of Work :: ", res);
      console.log("Work Class :: ", data.workClass);

      if (
        data.HeadCode ==
        "3054-2419(Roads and bridge repair maintenance program)"
      ) {
        let workNames = res.filter((item) => item.Work_Type === data.workClass);
        console.log("Work Names :: ", workNames);
        setWork(workNames);
      } else {
        setWork(res);
      }
      setLoading(false);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    GetTypesOfWork();
  }, [data.HeadCode, data.workClass, data.workType]);

  const handleBack = () => {
    nav(-1);
  };
  return (
    <>
      {data && (
        <div style={{ height: "91vh", overflowY: "auto" }}>
          <div
            className="col-12"
            style={{ backgroundColor: "#EFF3F8", padding: "2rem 0px 5px 0px" }}
          >
            <button
              className="btn btn-danger rounded-4 ms-auto"
              onClick={handleBack}
            >
              {" "}
              <i class="fa fa-arrow-left" aria-hidden="true" />
              {t("Back")}
            </button>

            <div className="col-12 m-auto my-5 budgetContainer">
              <div className="m-auto budgetElement">
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    paddingBottom: "10px",
                  }}
                >
                  <div>
                    <h5 className=" bg-light">
                      <img src={ProposalCreation32} />
                      {t("Edit Proposal")}
                    </h5>
                  </div>
                </div>

                <p
                  className="py-2 ps-1 fw-bold text-danger"
                  style={{ backgroundColor: "#FBE7E7" }}
                >
                  {t("Note : Fields marked with * are mandatory")}
                </p>
                {loading && (
                  <div
                    style={{
                      position: "fixed",
                      top: 0,
                      left: 0,
                      width: "100%",
                      height: "100%",
                      background: "rgba(255, 255, 255, 0.7)",
                      backdropFilter: "blur(4px)",
                      zIndex: 9999,
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <div
                      style={{
                        border: "6px solid #f3f3f3",
                        borderTop: "6px solid #007bff",
                        borderRadius: "50%",
                        width: "60px",
                        height: "60px",
                        animation: "spin 1s linear infinite",
                      }}
                    />
                    <style>
                      {`@keyframes spin {0% { transform: rotate(0deg); }100% { transform: rotate(360deg); }}`}
                    </style>
                  </div>
                )}

                <div className="budgetElement2">
                  <form action="">
                    <div className="col-12 elements">
                      <div className="row">
                        <div className="col-5">
                          <label>{t("Proposal ID")}</label>
                        </div>
                        <div className="col-7">
                          <input
                            type="text"
                            placeholder={t("Enter Proposal ID")}
                            className="form-control py-2"
                            value={data.PID}
                            disabled
                          />
                        </div>
                      </div>
                    </div>

                    <div className="col-12 elements">
                      <div className="row">
                        <div className="col-5">
                          <label>{t("HeadCode")}</label>
                        </div>
                        <div className="col-7">
                          <input
                            type="text"
                            className="form-control py-2"
                            value={data.HeadCode}
                            disabled
                          />
                        </div>
                      </div>
                    </div>

                    <div className="col-12 elements">
                      <div className="row">
                        <div className="col-5">
                          <label>{t("Year")}</label>
                        </div>
                        <div className="col-7">
                          {/* <select name="ProposalYear" value={data.ProposalYear} className='py-2' onChange={HandleChangeData} required>
                                                            <option value="">Select Financial Year</option>
                                                            <option value="2024-2025">2024 - 2025</option>
                                                            <option value="2025-2026">2025 - 2026</option>
                                                        </select> */}

                          <input
                            type="text"
                            placeholder={t("Enter Proposal Year")}
                            className="form-control py-2"
                            value={data.ProposalYear}
                            disabled
                          />
                        </div>
                      </div>
                    </div>

                    <div className="col-12 elements">
                      <div className="row">
                        <div className="col-5 my-auto">
                          <label className="my-auto">
                            {t("Taluka")}{" "}
                            <span className="text-danger fw-bold">*</span>
                          </label>
                        </div>
                        <div className="col-7">
                          {/* <select name="Taluka" value={data.Taluka} className='py-2' onChange={HandleChangeData}>
                                                <option value="">Select Taluka</option>
                                                {
                                                    Taluka &&
                                                    [...new Set(Taluka.map(val => val.ULBName))].map((ULBName, index) => (
                                                        <option value={ULBName} key={index}>{ULBName}</option>
                                                    ))
                                                }
                                                <option value={"Wakad"} >{"Wakad"}</option>
                                            </select> */}
                          {/* <select
                                                            name="Taluka"
                                                            value={data.TalukaSelection}
                                                            className='py-2'
                                                            onChange={HandleChangeData}
                                                            required
                                                        >
                                                            <option value="">Select Taluka</option>
                                                            {
                                                                Taluka &&
                                                                [...new Set(Taluka.map(val => val.ULBNameMarathi))].map(
                                                                    (ULBNameMarathi, index) => {
                                                                        const district = Taluka.find(t => t.ULBNameMarathi === ULBNameMarathi)?.District_Marathi || '';
                                                                        return (
                                                                            <option key={index} value={`${ULBNameMarathi}|${district}`}>
                                                                                {ULBNameMarathi}
                                                                            </option>
                                                                        )
                                                                    })
                                                            }
                                                        </select> */}

                          <input
                            type="text"
                            placeholder="Enter Constituency Name"
                            className="form-control py-2"
                            value={data.Taluka}
                            disabled
                          />
                        </div>
                      </div>
                    </div>

                    <div className="col-12 elements">
                      <div className="row">
                        <div className="col-5">
                          <label>{t("Constituency Name")}</label>
                        </div>
                        <div className="col-7">
                          <input
                            type="text"
                            placeholder="Enter Constituency Name"
                            className="form-control py-2"
                            name="ConstituencyName"
                            value={data.ConstituencyName}
                            disabled
                          />
                        </div>
                      </div>
                    </div>

                    <div className="col-12 elements">
                      <div className="row">
                        <div className="col-5">
                          <label>{t("Proposal File Number")}</label>
                        </div>
                        <div className="col-7">
                          <input
                            type="text"
                            placeholder="Enter Proposal File Number"
                            className="form-control py-2"
                            name="ProposalFileNumber"
                            value={data.ProposalFileNumber}
                            disabled
                          />
                        </div>
                      </div>
                    </div>

                    <div className="col-12 elements my-4">
                      <div className="row">
                        <div className="col-5">
                          <label>
                            {t("This involves multiple Gram Panchayat?")}{" "}
                            <span style={{ color: "red" }}>*</span>
                          </label>
                        </div>
                        <div
                          className="col-7"
                          style={{ display: "flex", gap: "15px" }}
                        >
                          <div>
                            <label>
                              <input
                                type="radio"
                                name="isMultipleGp"
                                value="Yes"
                                onChange={HandleChangeData}
                                checked={data.isMultipleGp === "Yes"}
                              />
                            </label>
                            <label>Yes</label>
                          </div>
                          <div>
                            <label>
                              <input
                                type="radio"
                                name="isMultipleGp"
                                value="No"
                                // onChange={(e) => {
                                //     HandleChangeData(e);

                                //     setData((prev) => ({
                                //         ...prev,
                                //         GramPanchayat:
                                //             prev.GramPanchayat.length > 0
                                //                 ? [prev.GramPanchayat[0]]
                                //                 : [],
                                //     }));
                                // }}
                                onChange={(e) => {
                                  HandleChangeData(e);
                                  setData((prev) => ({
                                    ...prev,
                                    GramPanchayat: [],
                                  }));
                                }}
                                checked={data.isMultipleGp === "No"}
                              />
                            </label>
                            <label>No</label>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* {
                                                urlType == "State" ? (
                                                    <div className="col-12 elements">
                                                        <div className="row">
                                                            <div className="col-5">
                                                                <label>Class Of Work</label>
                                                            </div>
                                                            <div className="col-7">
                                                                <input type="text" placeholder='Enter Proposal File Number' className='form-control py-2' name='ProposalFileNumber'
                                                                    value={data.workClass}
                                                                    disabled />
                                                            </div>
                                                        </div>
                                                    </div>
                                                )
                                                    : (
                                                        <div className="col-12 elements">
                                                            <div className="row">
                                                                <div className="col-5">
                                                                    <label>Class Of Work</label>
                                                                </div>
                                                                <div className="col-7">
                                                                    <select name="workClass" id=""
                                                                        value={data.workClass}
                                                                        onChange={HandleChangeData}
                                                                        className="form-select form-select-sm custom-select"
                                                                    >
                                                                        <option value="" >Choose Class Of Work</option>
                                                                        {WorkId && [...new Set(WorkId.map(item => item.Work_Type))].map((val, index) => (
                                                                            <option key={index} value={val}>{val || "N/A"}</option>
                                                                        ))}
                                                                    </select>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )
                                            } */}

                    <div className="col-12 elements">
                      <div className="row">
                        <div className="col-5">
                          <label>
                            {t("Class Of Work")}{" "}
                            <span style={{ color: "red" }}>*</span>
                          </label>
                        </div>
                        <div className="col-7">
                          <select
                            name="workClass"
                            id=""
                            value={data.workClass ?? ""}
                            onChange={(e) => {
                              setData((prev) => ({
                                ...prev,
                                workType: "",
                              }));
                              HandleChangeData(e);
                            }}
                            className="form-select form-select-sm custom-select"
                            required
                          >
                            <option value="">
                              {t("Choose Class Of Work")}
                            </option>
                            {WorkId &&
                              [...new Set(WorkId.map((item) => item.Work_Type))]
                                .sort()
                                .map((val, index) => (
                                  <option key={index} value={val}>
                                    {val || "N/A"}
                                  </option>
                                ))}
                          </select>
                        </div>
                      </div>
                    </div>

                    <div className="col-12 elements">
                      <div className="row">
                        <div className="col-5">
                          <label>
                            {t("Type of Work")}
                            <span style={{ color: "red" }}>*</span>
                          </label>
                        </div>
                        <div className="col-7">
                          <select
                            name="workType"
                            id=""
                            value={data.workType ?? ""}
                            onChange={HandleChangeData}
                            className="form-select form-select-sm custom-select"
                            required
                          >
                            <option value="">{t("Choose Type of Work")}</option>
                            {getWork &&
                              getWork.map((val, index) => {
                                return (
                                  <option key={index} value={val.Work_name}>
                                    {val.Work_name}
                                  </option>
                                );
                              })}
                          </select>
                        </div>
                      </div>
                    </div>

                    <div className="col-12 elements">
                      <div className="row">
                        <div className="col-5">
                          <label>
                            {t("Work Name")}{" "}
                            <span style={{ color: "red" }}>*</span>
                          </label>
                        </div>
                        <div className="col-7">
                          <input
                            type="text"
                            name="WorkName"
                            placeholder="Enter Work Name"
                            className="form-control form-control-sm custom-input"
                            value={data.WorkName}
                            onChange={HandleChangeData}
                            required
                          />
                        </div>
                      </div>
                    </div>

                    {userData?.RoleID !== 41 && (
                      <div className="col-12 elements">
                        <div className="row">
                          <div className="col-5">
                            <label>
                              {t("Job ID")}{" "}
                              <span style={{ color: "red" }}>*</span>
                            </label>
                          </div>
                          <div className="col-7">
                            <input
                              type="number"
                              name="JOB_ID"
                              pattern="[0-9]*"
                              placeholder={t("Enter Job Id here")}
                              className="form-control form-control-sm custom-input"
                              value={data.JOB_ID}
                              maxLength={12}
                              onChange={(e) => {
                                let value = e.target.value.replace(/\D/g, "");
                                HandleChangeData({
                                  target: { name: "JOB_ID", value },
                                });
                              }}
                              required
                            />
                          </div>
                        </div>
                      </div>
                    )}
                    <div className="col-12 elements">
                      <div className="row">
                        <div className="col-5">
                          <label>
                            {t("Road Category")}
                            <span style={{ color: "red" }}>*</span>
                          </label>
                        </div>
                        <div className="col-7">
                          <select
                            name="RoadCategory"
                            id=""
                            value={data.RoadCategory}
                            onChange={HandleChangeData}
                            className="form-select form-select-sm custom-select"
                            required
                          >
                            <option value="" disabled>
                              {t("Choose Road Category")}
                            </option>
                            <option>{t("Village Road")}</option>
                            <option>{t("Other District Road")}</option>
                          </select>
                        </div>
                      </div>
                    </div>

                    <div className="col-12 elements">
                      <div className="row">
                        <div className="col-5">
                          <label>
                            {t("Road Number")}{" "}
                            <span style={{ color: "red" }}>*</span>
                          </label>
                        </div>
                        <div className="col-7">
                          <input
                            type="text"
                            name="RoadNumber"
                            placeholder="Enter Road No."
                            className="form-control"
                            value={data.RoadNumber}
                            onChange={HandleChangeData}
                            required
                          />
                        </div>
                      </div>
                    </div>

                    <div className="col-12 elements">
                      <div className="row">
                        <div className="col-5">
                          <label>
                            {t("Proposed Length")}{" "}
                            <span style={{ color: "red" }}>*</span>
                          </label>
                        </div>
                        <div className="col-7">
                          <input
                            type="text"
                            name="proposedLength"
                            placeholder="Enter Proposed Length"
                            className="form-control"
                            value={data.proposedLength}
                            onChange={HandleChangeData}
                            required
                          />
                        </div>
                      </div>
                    </div>

                    {/* <div className="col-12 elements">
                      <div className="row">
                        <div className="col-5">
                          <label>
                            {t("Gram Panchayat")}{" "}
                            <span style={{ color: "red" }}>*</span>
                          </label>
                        </div>
                        <div className="col-7">
                          <div className="col-12">
                            {data.GramPanchayat.length > 0 && (
                              <input
                                type="text"
                                placeholder="Enter Constituency Name"
                                className="form-control py-2"
                                value={data.GramPanchayat.join(", ")}
                                disabled
                              />
                            )}
                          </div>

                          <div className="col-12">
                            <button
                              type="button"
                              onClick={() => {
                                if (
                                  !data.Taluka ||
                                  !data.isMultipleGp ||
                                  !data.HeadCode
                                ) {
                                  alert("Plz Fill Above Missing Data !!");
                                } else {
                                  // Copy current saved selection into temporary selection
                                  setTempGramPanchayat(data.GramPanchayat || []);
                                  setShowPopup(true);
                                }
                              }}
                              className="btn btn-success"
                            >
                              {t("Select Gram Panchayat")}
                            </button>
                          </div>

                          {showPopup && (
                            <div
                              style={{
                                position: "fixed",
                                top: 0,
                                left: 0,
                                width: "100%",
                                height: "100%",
                                background: "rgba(0, 0, 0, 0.21)",
                                backdropFilter: "blur(4px)",
                                zIndex: 999,
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                            >
                              <div
                                className="m-auto"
                                style={{
                                  background: "white",
                                  height: "400px",
                                  width: "450px",
                                  overflowY: "auto",
                                  overflowX: "hidden",
                                  padding: "20px",
                                }}
                              >
                                <button
                                  type="button"
                                  onClick={() => {
                                    if (
                                      data.isMultipleGp === "Yes" &&
                                      data.GramPanchayat.length < 2
                                    ) {
                                      alert(
                                        "You must select at least 2 Gram Panchayats.",
                                      );
                                      return;
                                    }
                                    setShowPopup(false);
                                  }}
                                  className="ms-auto"
                                  style={{
                                    background: "#b60101ff",
                                    border: "none",
                                    fontSize: "20px",
                                    cursor: "pointer",
                                    color: "#fff",
                                    lineHeight: "1",
                                    padding: "0",
                                    width: "30px",
                                    height: "30px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    borderRadius: "3px",
                                    fontWeight: "bold",
                                  }}
                                  aria-label="Close"
                                >
                                  ×
                                </button>

                                <div className="col-12">
                                  {[
                                    ...new Set(
                                      gramPanchayat.map(
                                        (gp) => gp.Village_Panchayat_Name,
                                      ),
                                    ),
                                  ].map((name, index) => (
                                    <div
                                      className="col-12"
                                      key={index}
                                      style={{
                                        marginBottom: "5px",
                                        fontSize: "12px",
                                      }}
                                    >
                                      <div className="row">
                                        <div className="col-2 m-auto">
                                          

                                          Added new input field 
                                          <input
                                            type="checkbox"
                                            id={`gp-${index}`}
                                            value={name}
                                            checked={tempGramPanchayat.includes(name)}
                                            onChange={(e) => {

                                              if (e.target.checked) {

                                                if (tempGramPanchayat.length >= 5) {
                                                  alert("You can select a maximum of 5 Gram Panchayats only.");
                                                  return;
                                                }

                                                setTempGramPanchayat(prev => [
                                                  ...prev,
                                                  name
                                                ]);

                                              } else {

                                                if (tempGramPanchayat.length <= 1) {
                                                  alert("You must select at least 1 Gram Panchayat.");
                                                  return;
                                                }

                                                setTempGramPanchayat(prev =>
                                                  prev.filter(gp => gp !== name)
                                                );
                                              }
                                            }}
                                          />

                                        </div>
                                        <div className="col-10 m-auto">
                                          <label
                                            className="col-12 my-auto"
                                            htmlFor={`gp-${index}`}
                                          >
                                            {name}
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                  ))}

                                  Close Button
                                  <div
                                    style={{
                                      textAlign: "center",
                                      marginTop: "20px",
                                    }}
                                  >
                                    <button
                                      type="button"
                                      onClick={() => {
                                        if (
                                          data.isMultipleGp === "Yes" &&
                                          data.GramPanchayat.length < 2
                                        ) {
                                          alert(
                                            "You must select at least 2 Gram Panchayats.",
                                          );
                                          return;
                                        }
                                        setShowPopup(false);
                                      }}
                                      style={{
                                        padding: "5px 15px",
                                        fontSize: "13px",
                                        borderRadius: "3px",
                                        border: "none",
                                        backgroundColor: "#b60101ff",
                                        color: "#fff",
                                        cursor: "pointer",
                                        fontWeight: "500",
                                      }}
                                    >
                                      Close
                                    </button>
                                  </div>

                                  <div style={{ textAlign: "center", marginTop: "20px" }}>
                                    <button
                                      type="button"
                                      onClick={() => {

                                        if (tempGramPanchayat.length < 1) {
                                          alert("Please select at least 1 Gram Panchayat.");
                                          return;
                                        }

                                        // SAVE selection
                                        setData(prev => ({
                                          ...prev,
                                          GramPanchayat: [...tempGramPanchayat]
                                        }));

                                        setShowPopup(false);
                                      }}
                                      style={{
                                        padding: "5px 15px",
                                        fontSize: "13px",
                                        borderRadius: "3px",
                                        border: "none",
                                        backgroundColor: "#198754",
                                        color: "#fff",
                                        cursor: "pointer",
                                        fontWeight: "500"
                                      }}
                                    >
                                      {t("Save Selection")}
                                    </button>
                                  </div>

                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div> */}

                    {/* Added new */}
                    <div className="col-12 elements">
                      <div className="row">
                        <div className="col-5">
                          <label>
                            {t("Gram Panchayat")}{" "}
                            <span style={{ color: "red" }}>*</span>
                          </label>
                        </div>
                        <div className="col-7">
                          <div className="col-12">
                            {data.GramPanchayat.length > 0 && (
                              <input
                                type="text"
                                placeholder="Enter Constituency Name"
                                className="form-control py-2"
                                value={data.GramPanchayat.join(", ")}
                                disabled
                              />
                            )}
                          </div>

                          <div className="col-12">
                            <button
                              type="button"
                              onClick={() => {
                                if (
                                  !data.Taluka ||
                                  !data.isMultipleGp ||
                                  !data.HeadCode
                                ) {
                                  alert("Plz Fill Above Missing Data !!");
                                } else {
                                  setTempGramPanchayat(
                                    data.GramPanchayat || [],
                                  );
                                  setShowPopup(true);
                                }
                              }}
                              className="btn btn-success"
                            >
                              {t("Select Gram Panchayat")}
                            </button>
                          </div>

                          {showPopup &&
                            (() => {
                              // ✅ चालू Taluka ची यादी + proposal मध्ये आधीच सेव्ह असलेली (जरी वेगळ्या तालुक्यातली असली तरी) — दोन्ही एकत्र दाखवा
                              const displayGPList = [
                                ...new Set([
                                  ...gramPanchayat.map(
                                    (gp) => gp.Village_Panchayat_Name,
                                  ),
                                  ...(data.GramPanchayat || []),
                                ]),
                              ];

                              return (
                                <div
                                  style={{
                                    position: "fixed",
                                    top: 0,
                                    left: 0,
                                    width: "100%",
                                    height: "100%",
                                    background: "rgba(0, 0, 0, 0.21)",
                                    backdropFilter: "blur(4px)",
                                    zIndex: 999,
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                  }}
                                >
                                  <div
                                    className="m-auto"
                                    style={{
                                      background: "white",
                                      height: "400px",
                                      width: "450px",
                                      overflowY: "auto",
                                      overflowX: "hidden",
                                      padding: "20px",
                                    }}
                                  >
                                    <button
                                      type="button"
                                      onClick={() => {
                                        if (
                                          data.isMultipleGp === "Yes" &&
                                          data.GramPanchayat.length < 2
                                        ) {
                                          alert(
                                            "You must select at least 2 Gram Panchayats.",
                                          );
                                          return;
                                        }
                                        setShowPopup(false);
                                      }}
                                      className="ms-auto"
                                      style={{
                                        background: "#b60101ff",
                                        border: "none",
                                        fontSize: "20px",
                                        cursor: "pointer",
                                        color: "#fff",
                                        lineHeight: "1",
                                        padding: "0",
                                        width: "30px",
                                        height: "30px",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        borderRadius: "3px",
                                        fontWeight: "bold",
                                      }}
                                      aria-label="Close"
                                    >
                                      ×
                                    </button>

                                    <div className="col-12">
                                      {/* ✅ सगळं एकत्र clear करण्यासाठी बटण */}
                                      {tempGramPanchayat.length > 0 && (
                                        <div
                                          style={{
                                            textAlign: "right",
                                            marginBottom: "10px",
                                            marginTop: "5px",
                                          }}
                                        >
                                          <button
                                            type="button"
                                            onClick={() =>
                                              setTempGramPanchayat([])
                                            }
                                            style={{
                                              padding: "4px 10px",
                                              fontSize: "12px",
                                              borderRadius: "4px",
                                              border: "1px solid #dc3545",
                                              background: "#fff",
                                              color: "#dc3545",
                                              cursor: "pointer",
                                              fontWeight: "500",
                                            }}
                                          >
                                            {t("Clear All")}
                                          </button>
                                        </div>
                                      )}

                                      {displayGPList.map((name, index) => (
                                        <div
                                          className="col-12"
                                          key={index}
                                          style={{
                                            marginBottom: "5px",
                                            fontSize: "12px",
                                          }}
                                        >
                                          <div className="row">
                                            <div className="col-2 m-auto">
                                              <input
                                                type="checkbox"
                                                id={`gp-${index}`}
                                                value={name}
                                                checked={tempGramPanchayat.includes(
                                                  name,
                                                )}
                                                onChange={(e) => {
                                                  if (e.target.checked) {
                                                    if (
                                                      tempGramPanchayat.length >=
                                                      5
                                                    ) {
                                                      alert(
                                                        "You can select a maximum of 5 Gram Panchayats only.",
                                                      );
                                                      return;
                                                    }
                                                    setTempGramPanchayat(
                                                      (prev) => [...prev, name],
                                                    );
                                                  } else {
                                                    // ✅ आता कुठलाही restriction नाही — पूर्ण मोकळेपणे uncheck करता येईल
                                                    setTempGramPanchayat(
                                                      (prev) =>
                                                        prev.filter(
                                                          (gp) => gp !== name,
                                                        ),
                                                    );
                                                  }
                                                }}
                                              />
                                            </div>
                                            <div className="col-10 m-auto">
                                              <label
                                                className="col-12 my-auto"
                                                htmlFor={`gp-${index}`}
                                              >
                                                {name}
                                              </label>
                                            </div>
                                          </div>
                                        </div>
                                      ))}

                                      <div
                                        style={{
                                          textAlign: "center",
                                          marginTop: "20px",
                                        }}
                                      >
                                        <button
                                          type="button"
                                          onClick={() => {
                                            if (tempGramPanchayat.length < 1) {
                                              alert(
                                                "Please select at least 1 Gram Panchayat.",
                                              );
                                              return;
                                            }
                                            setData((prev) => ({
                                              ...prev,
                                              GramPanchayat: [
                                                ...tempGramPanchayat,
                                              ],
                                            }));
                                            setShowPopup(false);
                                          }}
                                          style={{
                                            padding: "5px 15px",
                                            fontSize: "13px",
                                            borderRadius: "3px",
                                            border: "none",
                                            backgroundColor: "#198754",
                                            color: "#fff",
                                            cursor: "pointer",
                                            fontWeight: "500",
                                          }}
                                        >
                                          {t("Save Selection")}
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              );
                            })()}
                        </div>
                      </div>
                    </div>

                    <div className="col-12 elements">
                      <div className="row">
                        <div className="col-5">
                          <label>
                            {t("Work Amount")}{" "}
                            <span style={{ color: "red" }}>*</span>
                          </label>
                        </div>
                        <div className="col-7">
                          <input
                            type="number"
                            placeholder="Enter Proposal Work Amount"
                            className="form-control py-2"
                            name="ProposalAmount"
                            min={1}
                            onWheel={(e) => e.target.blur()}
                            onKeyDown={(e) => {
                              if (
                                ["e", "E", "+", "-"].includes(e.key) ||
                                (e.key === "." && e.target.value.includes(".")) // prevent multiple dots
                              ) {
                                e.preventDefault();
                              }
                            }}
                            value={data.ProposalAmount}
                            onChange={HandleChangeData}
                            required="true"
                          />
                        </div>
                      </div>
                    </div>

                    <div className="col-12 elements">
                      <div className="row">
                        <div className="col-5">
                          <label>{t("Remark")} </label>
                        </div>
                        <div className="col-7">
                          <input
                            type="text"
                            name="Remark"
                            placeholder="Enter Remark"
                            className="form-control"
                            value={data.Remark}
                            onChange={HandleChangeData}
                            required
                          />
                        </div>
                      </div>
                    </div>

                    {/* <div className="col-12 elements">
                                                <div className="row">
                                                    <div className="col-5">
                                                        <label>Proposal Copy</label>
                                                    </div>
                                                    <div className="col-7">
                                                        <input type="file" className='form-control py-2' id='ProposalCopy' />
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-12 elements">
                                                <div className="row">
                                                    <div className="col-5">
                                                        <label>Additional Supporting Document</label>
                                                    </div>
                                                    <div className="col-7">
                                                        <input type="file" className='form-control py-2' id='AdditionalSupportingDocument' />
                                                    </div>
                                                </div>
                                            </div> */}

                    <div className="col-12 ms-auto my-4">
                      <div className="row">
                        <div className="col-5"></div>
                        <div className="col-7">
                          <div
                            className="col-12"
                            style={{ display: "flex", gap: "10px" }}
                          >
                            <button
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                gap: "4px",
                                background:
                                  "linear-gradient(to right, #3b409e, #0067ab, #0f79ba, #0098d5)",
                                width: "8rem",
                                height: "2rem",
                                fontSize: "18px",
                              }}
                              onClick={handleSubmit}
                            >
                              <img src={submit} style={{ width: "15px" }} />{" "}
                              {t("Update")}
                            </button>
                            <button
                              type="button"
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                gap: "4px",
                                backgroundColor: "#f1594c",
                                width: "6rem",
                                height: "2rem",
                                fontSize: "16px",
                              }}
                              onClick={() => nav(-1)}
                            >
                              {" "}
                              <img src={Cancel32} style={{ width: "17px" }} />
                              {t("Cancel")}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default EditProposal;
